// extracted by mini-css-extract-plugin
module.exports = {"container":"Countdown_container__zKiko","counter":"Countdown_counter__27Cj4","label":"Countdown_label__SzxOZ"};